import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

@Injectable({ providedIn: 'root' })
export class GetAboutDataGqlService {
  readonly document = gql`
    query GetAboutData {
      aboutContents {
        name
        statsTitle
        stats
        text
        images {
          url
          width
          height
        }
      }
    }
  `;
}
